// components/ArtistInfo.tsx
import React from "react";
import { Link } from "react-router-dom";
import { Artist } from "../../data/types";
import "./ArtistInfo.css";

interface ArtistInfoProps {
  artist: Artist;
  className?: string;
}

const ArtistInfo: React.FC<ArtistInfoProps> = ({ artist, className = "" }) => {
  // A página do voador é resolvida pelo id do artista (ver findArtistBySlug)
  const artistUrl = `/voadores/${artist.id}`;
  const isModalContext = className.includes("modal-artist-info");

  return (
    <Link
      to={artistUrl}
      className={`artist-link ${className} ${
        isModalContext ? "modal-artist-link" : ""
      }`}
    >
      {artist.fullName ?? artist.name}
    </Link>
  );
};

export default ArtistInfo;
